/**
 * Base URL of the backend API host (no trailing slash), for displaying webhook URLs etc.
 * Prefer VITE_PUBLIC_API_URL when the browser uses a Vite proxy (origin is the dev server).
 */
export function getPublicApiBaseUrl(): string {
  const explicit = import.meta.env.VITE_PUBLIC_API_URL?.replace(/\/+$/, '');
  if (explicit) return explicit;

  const apiUrl = import.meta.env.VITE_API_URL?.replace(/\/+$/, '');
  if (apiUrl) {
    return apiUrl.replace(/\/api\/?$/i, '');
  }

  // Do NOT fall back to `window.location.origin`: on production the SPA runs on www but the API is
  // api.* — inferring www as the API host breaks OAuth and other full-page hits to `/api/...`.

  return '';
}

export function getWabaWebhookUrl(): string {
  const base = getPublicApiBaseUrl();
  if (!base) return '/api/waba/webhook';
  return `${base}/api/waba/webhook`;
}
